<template>
  <div class="box">
    <admin-box-item title="서비스 유형">
      <admin-form-item label="모집인원 제한">
        <div class="flex" style="gap:12px">
          <div v-for="(opt,idx) in option" :key="`opt-${idx}`" @click="reservePolicy.limit_type = opt.value"
              class="opt-item unselect" :class="{'opt-item-selected': opt.value === reservePolicy.limit_type}">
            <div class="flex" style="gap: 8px">
              <div class="circle"></div>
              <div class="opt-label weight-700 size-13">{{ opt.label }}</div>
            </div>
            <div class="desc">{{ opt.desc }}</div>
          </div>
        </div>
      </admin-form-item>

      <div v-if="reservePolicy.limit_type === 0" style="margin-top:24px">
        <admin-form-item label="모집인원">
          <div class="flex-align" style="width:154px;gap:0 16px;padding-bottom:10px">
            <input type="number" class="input-border"
                   v-model="prod.stock" :disabled="prod.stock_type === 1">
            <lp-check-bool label="무한대" :checkedVal.sync="isInfinite"></lp-check-bool>
          </div>
        </admin-form-item>
        <admin-form-item label="1회 구매 가능 수량">
          <lp-check-bool :checked-val.sync="reservePolicy.limit_count" style="margin-top:4px"
                         label="1회당 구매 가능 수량을 제한합니다. (최소 2명 이상, 최대 4명 까지만 신청가능 등, 신청 인원의 조건이 필요할 때)"></lp-check-bool>

          <div class="flex-align" style="margin-top:12px" v-if="reservePolicy.limit_count">
            <div style="margin-right:4px">최소</div>
            <input type="number" v-model.number="reservePolicy.minimum">
            <div style="margin:0 8px">~</div>
            <div style="margin-right:4px">최대</div>
            <input type="number" v-model.number="reservePolicy.maximum">
          </div>
        </admin-form-item>
      </div>
      <div class="opt-desc" v-else>*옵션 패널에서 옵션 생성 후 인원/1회 구매 가능 수량을 제한 할 수 있습니다.</div>
    </admin-box-item>

  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  export default {
    name: "PanelReservePolicy",
    components: {LpCheckBool},
    props: {
      prod: {
        type: Object
      },
      reservePolicy: {
        type: Object
      }
    },
    created() {
      this.isInfinite = this.prod.stock_type === 1;
    },
    watch: {
      isInfinite(n) {
        this.prod.stock_type = n ? 1 : 0;
      }
    },
    data() {
      return {
        isInfinite: false,
        option: [
          {
            label: '일정별 모집인원 제한',
            desc: '선택한 옵션과 무관하게 일정별로 모집할 전체 인원을 제한',
            value: 0
          },
          {
            label: '옵션별로 모집인원 제한',
            desc: '성별에 옵션 따라 모집인원을 제한하는 등 옵션별로 인원을 제한합니다.',
            value: 1
          }
        ],
      }
    }
  }
</script>

<style lang="stylus" scoped>
  $primary = #ff5722
  .opt-item
    border 1px solid #dddddd
    border-radius 4px
    padding 16px 24px
    color #363636
    .circle
      background-color white
      border 1px solid #cccccc
      border-radius 100%
      width 16px
      height 16px
    .desc
      color #787878
      font-size 13px
      margin-top 4px

  .opt-item-selected
    border 1px solid $primary
    background-color #fff0eb
    .circle
      border 3px solid $primary
    .opt-label
      color $primary
  label
    font-size 13px
    color #787878
  input[type=number]
    width 80px

  .opt-desc
    font-size 13px
    color #787878
</style>
